module.exports = __webpack_public_path__ + "img/Abfahrk_Fahrzeug.ef63b5ea.svg";